import { ReactNode, startTransition, useEffect, useState } from "react";

/**
 * Renders its children in a transition after it's mounted (until then the fallback), so that React renders them
 * in short slices instead of in the long task of the render or commit that mounts this component.
 *
 * Used for the map: react-leaflet creates the map while React commits the MapContainer and then rerenders it with
 * the map. React renders that update synchronously, and before it, runs the effects of the whole commit - in the
 * commit that mounts the app's UI, all of it at once, in one long task that blocks the page.
 */
export const RenderInTransition = ({
  children,
  fallback = null,
}: {
  children: ReactNode;
  /** Shown until the children are rendered, e.g. an element that takes up the same space */
  fallback?: ReactNode;
}) => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    startTransition(() => setShown(true));
  }, []);

  return shown ? children : fallback;
};
